<div #searchBarContainer class="search-bar-container" fxLayout="column" fxFlex>
  <div class="bar add-bottom-radius" *ngIf="themeType !=='Default'" fxFlex="90%" [class.remove-bottom-radius]="removeSearchBarBottomBorders && searchKeyLength > 0">
    <i class="material-icons search-icon" data-icon="search"></i>
    <input type="text" placeholder="Type to search..." [formControl]="searchInput" class="search-input" fxFlex
      #initialFocus id="searchInput"/>
      <button mat-icon-button class="clear-icon" (click)="setEmpty()" id="setEmpty" *ngIf="featureTags['search_clear_btn'] === false"> 
        <span class="clearBtn">Clear</span>
      </button>
    <div class="pl-80 closeBtn">
      <button mat-icon-button class="bg-white" (click)="hideSearch()" id="hideSearch">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="bar add-bottom-radius" *ngIf="themeType =='Default'" [class.remove-bottom-radius]="removeSearchBarBottomBorders && searchKeyLength > 0">
    <i class="material-icons search-icon" data-icon="search"></i>
    <input type="text" placeholder="Type to search..." [formControl]="searchInput" class="search-input" fxFlex
      #initialFocus id="searchInput"/>      
        <button mat-icon-button class="clear-icon" (click)="setEmpty()" id="setEmpty" *ngIf="featureTags['search_clear_btn'] === false"> 
          <span class="clearBtn">Clear</span>
        </button>
        <!-- <button mat-icon-button class="clear-icon" (click)="setEmpty()" id="setEmpty"> 
          <mat-icon class="ft-size-18">close</mat-icon> 
        </button> -->
  </div>
  <div #searchResult *ngIf="searchKeyLength > 0 && (showSearchResultNotFoundMsg || searchProducts.length > 0)"
    class="result add-bottom-radius list-align" (scroll)="resultScrollHandler($event)" 
    [ngClass]="{resultMobile: ftagResultMobile}">
    <p class="not-found-warning text-muted" *ngIf="showSearchResultNotFoundMsg">
      product not found!
    </p>
    <mat-list class="list" *ngIf="searchProducts.length > 0">
      <mat-list-item class="list-item" ngClass.gt-sm="padding-desktop" ngClass.lt-md="padding-mobile"
        *ngFor="let product of searchProducts">
        <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_search_bar_ui_changes']">
          <div class="container" fxLayout="row" ngClass.gt-sm="desktop" ngClass.lt-md="mobileScreen" fxLayout.lt-md="row" 
        fxLayoutAlign.lt-md="start center" fxLayoutGap="10px" fxFlex>
          <div class="imageContainer hand-hover"
            (click)="searchNavigation(product.category_name,product.website_title,product.website_url)" id="searchNavigation">
            <!-- <img src="https://cb.routeworx.site/images/product_image/1/NAT01_1_xs.jpeg" [alt]="product.product_code"> -->
            <img src="data:," [imgName]="
                product?.product_image1 || product?.product_image2 || ''
              " imgType="products" imgSize="xs" imagePreload [alt]="product.description" />
          </div>
          <div class="proNameAndPrice" fxLayout="row" fxLayout.lt-md="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-md="space-between center" fxLayoutAlign.lt-sm="auto" fxLayoutGap.lt-md="10px" fxFlex>
            <div class="content hand-hover setWidth" fxLayout="column" fxFlex="100%" fxFlex.lt-md="auto"
              (click)="searchNavigation(product.category_name,product.website_title,product.website_url)">
              <span class="category_name text-muted text-truncate">{{ product.category_name }}</span>
              <span class="description text-truncate text-truncatedes">{{ product.description }}</span>
            </div>
            <div class="content" fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutAlign.lt-md="space-between center"
              fxLayoutGap="15px" fxFlex class="priceAndBtn">
              <span class="retail_price hand-hover">${{product.retail_price[0] | number:'1.2-2'}}</span>
              <ng-container *ngIf="!!featureTags && featureTags['solr_search_out_of_stock']; else noOutOfStock">
                <ng-container *ngIf="featureTags && featureTags['ftags_membership']">
                  <button mat-stroked-button color="primary" matTooltip="Add to order" class="cart-btn-small bgBtn"  *ngIf="product['is_membership'][0] == 0 && (product['restrict_orders'][0] == 0 || (product['restrict_orders'][0] == 1 && product['stock_in_hand'][0] != 0))"
                    (click)="addToCartBtnClicked($event, product)" id="searchAddtoCart">                
                    Add To Order
                  </button>
                  <button mat-stroked-button color="primary" matTooltip="Purchase Now" class="cart-btn-small bgBtn" *ngIf="product['is_membership'][0]==1 "
                    (click)="addToCartBtnClicked($event, product)" id="searchAddtoCart">                
                    Purchase Now
                  </button>
                </ng-container>
                <ng-container *ngIf="featureTags && !featureTags['ftags_membership']">
                  <button mat-stroked-button color="primary" matTooltip="Add to order" class="cart-btn-small bgBtn" *ngIf="product['restrict_orders'][0]==0 || (product['restrict_orders'][0] == 1 && product['stock_in_hand'][0]!=0)"
                    (click)="addToCartBtnClicked($event, product)" id="searchAddtoCart">                
                    Add To Order
                  </button>
                </ng-container>
                <div *ngIf="product['restrict_orders'][0] == 1 && product['stock_in_hand'][0]==0" class="cart-btn-small outOfStockBtn">
                  <i>Sold Out</i>
                </div>
              </ng-container>
              <ng-template #noOutOfStock>
                <button mat-stroked-button color="primary" matTooltip="Add to order" class="cart-btn-small bgBtn"
                  (click)="addToCartBtnClicked($event, product)" id="searchAddtoCart">
                  <!-- <i class="material-icons" data-icon="add_shopping_cart"></i> -->
                  Add To Order
                </button>
              </ng-template>
            </div>
          </div>
        </div>
        </ng-container>
        <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_search_bar_ui_changes']">
        <div class="container" fxLayout="row" ngClass.gt-sm="desktop" ngClass.lt-md="mobile" fxLayout.lt-md="row" 
        fxLayoutAlign.lt-md="space-between center" fxLayoutGap="5px" fxFlex>
          <div class="image hand-hover" fxHide.lt-md
            (click)="searchNavigation(product.category_name,product.website_title,product.website_url)" id="searchNavigation">
            <!-- <img src="https://cb.routeworx.site/images/product_image/1/NAT01_1_xs.jpeg" [alt]="product.product_code"> -->
            <img src="data:," [imgName]="
                product?.product_image1 || product?.product_image2 || ''
              " imgType="products" imgSize="xs" imagePreload [alt]="product.description" />
          </div>
          <div class="content hand-hover setWidth" fxLayout="column" fxFlex="100%" fxFlex.lt-md="auto"
            (click)="searchNavigation(product.category_name,product.website_title,product.website_url)">
            <span class="category_name text-muted text-truncate">{{ product.category_name }}</span>
            <span class="description text-truncate text-truncatedes">{{ product.description }}</span>
          </div>
          <div class="content" fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutAlign.lt-md="space-between center"
            fxLayoutGap="15px" fxFlex class="priceAndBtn">
            <span class="retail_price hand-hover">${{product.retail_price[0] | number:'1.2-2'}}</span>
            <ng-container *ngIf="!!featureTags && featureTags['solr_search_out_of_stock']; else noOutOfStock">
              <button mat-stroked-button color="primary" matTooltip="Add to order" class="cart-btn-small" *ngIf="product['restrict_orders'][0]==0 || (product['restrict_orders'][0] == 1 && product['stock_in_hand'][0]!=0)"
                (click)="addToCartBtnClicked($event, product)" id="searchAddtoCart">                
                Add To Order
              </button>
              <div *ngIf="product['restrict_orders'][0] == 1 && product['stock_in_hand'][0]==0" class="outofstock">
                Sold Out
              </div>
            </ng-container>
            <ng-template #noOutOfStock>
              <button mat-stroked-button color="primary" matTooltip="Add to order" class="cart-btn-small"
                (click)="addToCartBtnClicked($event, product)" id="searchAddtoCart">
                <!-- <i class="material-icons" data-icon="add_shopping_cart"></i> -->
                Add To Order
              </button>
            </ng-template>
          </div>
        </div>
        </ng-container>
      </mat-list-item>
      <div *ngIf="showSkeletonLoader">
        <div class="skeleton-loader">
          <div class="image-skeleton">
            <ngx-skeleton-loader
              count="1"
              appearance="circle"
              [theme]="{
                'width.px': '100px',
                'height.px': '100px',
                'border-radius': '10px'
              }"
            ></ngx-skeleton-loader>
          </div>
          <div class="content-skeleton">
            <ngx-skeleton-loader
              count="1"
              [theme]="{ 
                height: '15px',
                width: '150px'
              }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"     
              [theme]="{ height: '18px' }"
            ></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </mat-list>
    <!-- / if search request is success && products found than show this list-->
  </div>
</div>